import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { getData } from "./data"
import * as moment from "moment"
import TableLoader from "components/Common/TableLoader"

function Table(props) {
  const { data } = props
  const columns = [
    {
      dataField: "created_at",
      text: "Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "bonus_by.phone_number",
      text: "Bonus By",
      sort: true,
      formatter: (cell, row) => (
        <>
          {" "}
          {row?.bonus_by == null
            ? "Cron"
            : row?.bonus_by?.phone_number == null
            ? row?.bonus_by?.name
            : row?.bonus_by?.phone_number}
        </>
      ),
    },
    {
      dataField: "bonus_to.phone_number",
      text: "Bonus To",
      sort: true,
      formatter: (cell, row) => <> {row?.bonus_to?.phone_number}</>,
    },
    {
      dataField: "bonus_to.user_id",
      text: "UserID",
      sort: true,
      formatter: (cell, row) => <> {row?.bonus_to?.id}</>,
    },
    {
      dataField: "bonus_to.pragmatic_player_id",
      text: "PragmaticID",
      sort: true,
      formatter: (cell, row) => <> {row?.bonus_to?.pragmatic_player_id}</>,
    },
    {
      dataField: "bonus_type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "bonus_amount",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row?.bonus_amount).toLocaleString("en-GB")}</>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "day",
      order: "asc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data.length,
    custom: true,
  }

  return (
      <>
        <Card>
          <CardBody>
            <div className="mb-4 h4 card-title">{"Bonus Report"}</div>
            {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField="id"
                columns={columns}
                data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                      keyField="id"
                      data={data}
                      columns={columns}
                      bootstrap4
                      search
                  >
                    {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="6">
                              <Row>
                                <Col sm="6">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar {...toolkitProps.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="6">
                                  <div>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xls-button"
                                        className="download-table-xls-button w-md btn btn-primary"
                                        table="hidden-table-to-xls"
                                        filename={`Bonus-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                        sheet="tablexls"
                                        buttonText="Download"
                                        type="button"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm={6}></Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable id="table-to-xls"
                                                keyField="id"
                                                responsive
                                                bordered={false}
                                                striped={false}
                                                defaultSorted={defaultSorted}
                                                classes={
                                                  "table align-middle table-nowrap table-check"
                                                }
                                                headerWrapperClasses={"table-light"}
                                                {...toolkitProps.baseProps}
                                                {...paginationTableProps}
                                                rowClasses={"mytable-hover-row"}
                                />
                              </div>
                            </Col>
                          </Row>
                          <div className="pagination pagination-rounded justify-content-end">
                            <PaginationListStandalone {...paginationProps} />
                          </div>

                          {/* Hidden table for export */}
                          <table id="hidden-table-to-xls" style={{ display: 'none' }}>
                            <thead>
                              <tr>
                                {columns.map((column, index) => (
                                  <th key={index}>{column.text}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {columns.map((column, colIndex) => (
                                    <td key={colIndex}>
                                      {column.formatter ? column.formatter(row[column.dataField], row) : row[column.dataField]}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </React.Fragment>
                    )}
                  </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
          </CardBody>
        </Card>
      </>
  )
}

export default Table
